<form [formGroup]="damageCodeSearchTextForm">
  <div>
    <mc-input
      hiddenlabel
      placeholder="Search for a damage code"
      fit="small"
      ngDefaultControl
      formControlName="searchText"
      (keyup.enter)="applySearchTextFilters()"
      icon="magnifying-glass"
      [clearbutton]="true"
      (clearbuttonclick)="applySearchTextFilters()"
      [attr.invalid]="isControlInErrorState(this.damageCodeSearchTextForm.controls.searchText)">
      @if (this.damageCodeSearchTextForm.controls.searchText.hasError('pattern')) {
        <span slot="errormessage">Incorrect damage code</span>
      }
    </mc-input>
  </div>
</form>
